var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import "./games.css";
import { useEffect, useState } from "react";
import { Storage } from "../../services/localstorege.service";
import { api } from "../../services/http.service";
import { env } from "../../constants/global.constants";
import _ from "lodash";
import iconRight from "../../assets/icons/right-arrow.png";
import { isMobile } from "../../App";
import { gameNavigationMiddleware, gtmSelectItem, gtmViewItemList, useForceUpdate, loginRequired, } from "../../services/misc.functions";
import { useNavigate, useParams, useLocation } from "react-router";
import { auth, authSubject } from "../../store/auth.store";
import paths from "../../paths";
import Game from "./game/game";
export function Games() {
    var _this = this;
    var params = useParams();
    var forceUpdate = useForceUpdate();
    var location = useLocation();
    var _a = useState([]), gamesList = _a[0], setGamesList = _a[1];
    var navigate = useNavigate();
    useEffect(function () {
        getGames().then(function (res) {
            setGamesList(res);
            gtmViewItemList(res, "Oyunlar");
        });
    }, [params, location.pathname]);
    useEffect(function () {
        var auth_subscriber = authSubject.subscribe(function (res) {
            forceUpdate();
        });
        return function () {
            auth_subscriber.unsubscribe();
        };
    }, []);
    var getGames = function () { return __awaiter(_this, void 0, void 0, function () {
        var games;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    games = Storage.get("games");
                    if (games) {
                        if (params.subpage === "yeni-oyunlar") {
                            return [2 /*return*/, games.filter(function (game) {
                                    return game.tag === "Yeni";
                                })];
                        }
                        else if (params.subpage === "gelecek-oyunlar") {
                            return [2 /*return*/, games.filter(function (game) {
                                    return game.is_active === false;
                                })];
                        }
                        else {
                            return [2 /*return*/, games];
                        }
                    }
                    return [4 /*yield*/, api.start("get", env.accounting_api + "/games/api/list-game/", null, false).then(function (res) {
                            if (res && res.status) {
                                var d = _.orderBy(res.data, ["ordering"], "asc");
                                Storage.set("games", d, 60 * 60 * 5);
                                if (params.subpage === "yeni-oyunlar") {
                                    return d.filter(function (game) {
                                        return game.tag === "Yeni";
                                    });
                                }
                                else if (params.subpage === "gelecek-oyunlar") {
                                    return d.filter(function (game) {
                                        return game.is_active === false;
                                    });
                                }
                                else {
                                    return d;
                                }
                            }
                            else {
                                return [];
                            }
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    // create function to capital first letter of string
    var gameNameFixer = function (string) {
        if (string == "KAZI Kazan") {
            return "Kazı Kazan";
        }
        else if (string == "MAYIN Tarlası") {
            return "Mayın Tarlası";
        }
        else if (string == "AŞAĞI YUKARI") {
            return "Aşağı Yukarı";
        }
        else if (string == "Süper PENALTI") {
            return "Süper Penaltı";
        }
        else if (string == "ŞANSLI 6") {
            return "Şanslı 6";
        }
        else if (string == "HIZLI Tombala")
            return "Hızlı Tombala";
        else {
            return string;
        }
    };
    if (params.subpage && params.subpage !== "yeni-oyunlar" && params.subpage && params.subpage !== "gelecek-oyunlar") {
        return _jsx(Game, {});
    }
    var gameTabs = [
        {
            key: "all",
            label: "🎮 Dijital Oyunlar",
            isActive: params.subpage === undefined,
            path: paths.games.url,
        },
        {
            key: "new",
            label: "⭐ Yeni Oyunlar",
            isActive: params.subpage === "yeni-oyunlar",
            path: "".concat(paths.games.url, "/yeni-oyunlar"),
        },
        {
            key: "upcoming",
            label: "⏳ Gelecek Oyunlar",
            isActive: params.subpage === "gelecek-oyunlar",
            path: "".concat(paths.games.url, "/gelecek-oyunlar"),
        },
    ];
    return (_jsxs(_Fragment, { children: [isMobile && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row mt-3 raffle-page-title-bar" }, { children: _jsx("h1", __assign({ className: "fs-5 fw-bold mx-2 text-uppercase" }, { children: "Dijital Oyunlar" })) })), _jsx("div", __assign({ className: "row inner-page-top-tabs" }, { children: _jsx("div", __assign({ className: "col-12" }, { children: _jsx("div", __assign({ className: "custom-tabs custom-tabs-mobile" }, { children: gameTabs.map(function (tab) { return (_jsx("div", __assign({ className: "custom-tab-item ".concat(tab.isActive ? "active" : ""), role: "button", tabIndex: 0, onClick: function () { return navigate(tab.path); }, onKeyDown: function (event) {
                                        if (event.key === "Enter" || event.key === " ") {
                                            event.preventDefault();
                                            navigate(tab.path);
                                        }
                                    } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: tab.label })) }), tab.key)); }) })) })) }))] })), !isMobile && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row mt-3 raffle-page-title-bar" }, { children: _jsx("h1", __assign({ className: "fs-5 fw-bold mx-2 text-uppercase" }, { children: "Dijital Oyunlar" })) })), _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "mb-0 mt-1" }, { children: _jsxs("div", __assign({ className: "custom-tabs mb-0" }, { children: [_jsx("div", __assign({ className: "custom-tab-item ".concat(params.subpage === undefined ? 'active' : ''), onClick: function () { return navigate(paths.games.url); } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: "\uD83C\uDFAE Dijital Oyunlar" })) })), _jsx("div", __assign({ className: "custom-tab-item ".concat(params.subpage === "yeni-oyunlar" ? 'active' : ''), onClick: function () { return navigate(paths.games.url + "/yeni-oyunlar"); } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: "\u2B50 Yeni Oyunlar" })) })), _jsx("div", __assign({ className: "custom-tab-item ".concat(params.subpage === "gelecek-oyunlar" ? 'active' : ''), onClick: function () { return navigate(paths.games.url + "/gelecek-oyunlar"); } }, { children: _jsx("h2", __assign({ className: "fs-6 fw-bold mb-0" }, { children: "\u23F3 Gelecek Oyunlar" })) }))] })) })) }))] })), _jsx("div", __assign({ className: "row games-list-row" }, { children: gamesList.map(function (game, key) {
                    var _a, _b, _c;
                    return (_jsx("div", __assign({ className: "col-2 col-lg-2 col-mobile-6 mb-4 pointer", onClick: function () {
                            gameNavigationMiddleware(game, navigate);
                            gtmSelectItem([game], "Oyunlar");
                        } }, { children: _jsx("div", __assign({ className: "game-card", style: { backgroundImage: "url(".concat(env.cdn_host + "/media/" + game.image, ")") }, onClick: function () { return gameNavigationMiddleware(game, navigate); } }, { children: _jsxs("div", __assign({ className: "play-button-wrapper\n                                                    ".concat(game.is_active !== true && !(((_a = auth.member) === null || _a === void 0 ? void 0 : _a.id) && auth.remaining_games.includes(game.id)) ? "passive" : "", "\n                                                    ").concat(game.is_active !== true && ((_b = auth.member) === null || _b === void 0 ? void 0 : _b.id) && auth.remaining_games.includes(game.id) ? "alerted" : "", "\n                                                ") }, { children: [_jsxs("span", __assign({ className: "play-button-text" }, { children: [game.is_active === true && _jsx(_Fragment, { children: "HEMEN OYNA" }), game.is_active !== true && game.reminer !== true && (_jsx(_Fragment, { children: ((_c = auth.member) === null || _c === void 0 ? void 0 : _c.id) && auth.remaining_games.includes(game.id)
                                                    ? "HATIRLATICI KURULDU"
                                                    : "⏰ HATIRLAT" }))] })), game.is_active === true && (_jsx("span", __assign({ className: "play-button-icon", onClick: function (e) {
                                            e.stopPropagation();
                                            if (!auth.member)
                                                return loginRequired(navigate);
                                            if (auth.remaining_games.includes(game.id))
                                                return;
                                            api.start("post", env.accounting_api + "/games/api/reminder-game/", { game_id: game.id }, true);
                                            authSubject.next(__assign({}, auth)); // force refresh
                                        } }, { children: _jsx("img", { src: iconRight, alt: ">" }) })))] })) })) }), "games-list-".concat(key)));
                }) }))] }));
}
